import Tippy from '@tippyjs/react';
import React, { PropsWithChildren } from 'react';
import tippyProps from '../../../../../../../shareables/foundation/front-end/utils/tippy-props';


// Define the accepted props
interface Props extends PropsWithChildren {
	show: boolean;
	content: string;
}


// Function component
const ConditionalTooltip: React.FC<Props> = ({ show, content, children }) =>
	show ? (
		<Tippy {...tippyProps} content={content}>
			<span aria-label={content}>{children}</span>
		</Tippy>
	) : (
		<React.Fragment>{children}</React.Fragment>
	);

export default ConditionalTooltip;
